import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { phrasesSelectorChangePriceRate } from '../../actions/phrases-selector/persistentData';
import {
    PhrasesSelectorFooter,
    PhrasesSelectorFooterProps
} from '../../components/PhrasesSelector/PhrasesSelectorFooter/PhrasesSelectorFooter';
import {
    selectPhrasesSelectorData,
    selectPhrasesSelectorPriceRateEnabled
} from '../../selectors/phrasesSelector/phrasesSelector';
import { GroupId } from '../../typings/groups';
import { PhrasesSelectorWizardId } from '../../typings/phrases';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    wizardId: PhrasesSelectorWizardId;
    groupId: GroupId;
    onSubmit: () => void;
}

type StateProps = TStateProps<PhrasesSelectorFooterProps, OwnProps>;
type DispatchProps = TDispatchProps<PhrasesSelectorFooterProps, OwnProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { wizardId } = ownProps;
    const [, { keywords, minusPhrases, priceRate }] = selectPhrasesSelectorData(state, wizardId);
    const isPriceRateEnabled = selectPhrasesSelectorPriceRateEnabled(state, wizardId);

    const {
        grid,
        commonData: { constants }
    } = state;
    const { workCurrency } = grid.clientInfo;

    let priceRateLimit = null;
    if (constants) {
        priceRateLimit = constants.currencyConstants[workCurrency];
    }

    const hasPhrases = keywords.length !== 0 || minusPhrases.length !== 0;

    return {
        hasPhrases,
        isPriceRateEnabled,
        priceRate,
        priceRateLimit,
        workCurrency
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { groupId } = ownProps;

    return {
        onPriceRateChange(rate: number) {
            dispatch(phrasesSelectorChangePriceRate(groupId, rate));
        }
    };
};

export const PhrasesSelectorFooterContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(PhrasesSelectorFooter);
